// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OQKU","title":"styles_title__2yNUk"};